import { AbstractList, Details, Disclosures, Edit, EditGroup, EditType, InvitationEmails, ListGroups } from ".";
import { is, List } from "immutable";
import * as React from "react";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import * as redux from "redux";
import * as Actions from "../../actions";
import * as Comp from "../../components";
import * as M from "../../models";
import { AppState } from "../../store";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    ...Comp.Base.DefaultListViewStatePropsMap(state, ownProps),
    events: state.adminAbstracts.events,
    loadingEvent: state.adminAbstracts.loadingEvent,
    subscribedAbstracts: state.abstract.subscribedEventAbstracts,
    subscribedEvents: state.adminEvents.subscribedEvents,
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
    ...Comp.Base.DefaultDispatchPropsMap(dispatch),
    loadEvent: (eventId: number) => dispatch(Actions.AdminAbstract.loadEvent(eventId)),
    subscribeToEvent: (eventId: number) => dispatch(Actions.AdminEvent.subscribeToEvent(eventId)),
    toggleEventLoading: (eventId: number, loading: boolean) => dispatch(Actions.AdminAbstract.toggleLoadingEvent(eventId, loading)),
});

type OwnProps = RouteComponentProps<{
    eventId: string;
}> & {
};

type ConnectedState = Comp.Base.DefaultConnectedState & {
    events: List<M.Abstract.AbstractEvent>;
    loadingEvent: M.Generic.ItemLoadingState;
    subscribedAbstracts: M.Generic.ResourceUpdated;
    subscribedEvents: M.Generic.ResourceUpdated;
};

type ConnectedDispatch = Comp.Base.DefaultConnectedDispatch & {
    loadEvent: (eventId: number) => void;
    subscribeToEvent: (eventId: number) => void;
    toggleEventLoading: (eventId: number, loading: boolean) => void;
};

interface OwnState {
    event?: M.Abstract.AbstractEvent;
}

type CombinedProps = ConnectedState & ConnectedDispatch & OwnProps;

class AdminAbstractsRoutesComponent extends React.Component<CombinedProps, OwnState> {
    public constructor(props: any) {
        super(props);
        this.state = {
        };
    }

    public async componentDidMount() {
        await this.initializeComponent();
    }

    public componentDidUpdate(prevProps: Readonly<CombinedProps>) {
        const eventId = this.getEventId();

        if (!is(prevProps.events, this.props.events))
            this.loadEventFromState();

        if (!is(prevProps.match.params.eventId, this.props.match.params.eventId)) {
            console.log("Event IDs are different", prevProps.match.params.eventId, this.props.match.params.eventId);
            this.initializeComponent();
        }

        if (!is(prevProps.websocket, this.props.websocket))
            this.props.subscribeToEvent(eventId);

        if (!is(prevProps.subscribedEvents[eventId], this.props.subscribedEvents[eventId]))
            this.props.loadEvent(eventId);

        if (!is(prevProps.subscribedAbstracts[eventId], this.props.subscribedAbstracts[eventId]))
            this.props.loadEvent(eventId);
    }

    public render() {
        const match = this.props.match;
        const eventId = this.getEventId();
        const loading = !!this.props.loadingEvent[eventId];

        return <Comp.Generic.WrapperLess>

            <Comp.Access.AdminRoute exact path={match.path} render={(props) => <AbstractList event={this.state.event} eventId={eventId} loadingEvent={loading} { ...props } />} />
            <Comp.Access.AdminRoute exact path={match.path + "/details/:guid"} render={(props) => <Details eventId={eventId} { ...props} />} />
            <Comp.Access.AdminRoute exact path={match.path + "/disclosures"} render={(props) => <Disclosures eventId={eventId} { ...props} />} />
            <Comp.Access.AdminRoute path={match.path + "/edit/:guid"} render={(props) => <Edit eventId={eventId} { ...props} />} />
            <Comp.Access.AdminRoute exact path={match.path + "/groups"} render={(props) => <ListGroups eventId={eventId} { ...props} />} />
            <Comp.Access.AdminRoute exact path={match.path + "/group/:groupId"} render={(props) => <EditGroup eventId={eventId} { ...props} />} />
            <Comp.Access.AdminRoute exact path={match.path + "/type/:typeId"} render={(props) => <EditType eventId={eventId} { ...props} />} />
            <Comp.Access.AdminRoute exact path={match.path + "/acceptance-emails"} render={(props) => <InvitationEmails eventId={eventId} { ...props} />} />

        </Comp.Generic.WrapperLess>;
    }

    private getEventId(props?: Readonly<CombinedProps>) {
        return parseInt(props
            ? props.match.params.eventId
            : this.props.match.params.eventId, 10);
    }

    private async initializeComponent() {
        const eventId = this.getEventId();

        await this.loadEventFromState(true);
        this.props.loadEvent(eventId);
    }

    private loadEventFromState(toggleLoading: boolean = false) {
        const eventId = this.getEventId();
        const evt = this.props.events.find((x: M.Abstract.AbstractEvent) => x.eventId === eventId);

        if (evt) {
            this.setState({
                ...this.state,
                event: evt,
            });
        }
        else if (toggleLoading)
            this.props.toggleEventLoading(eventId, true);
    }
}

export const AdminAbstractsRoutes: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(withRouter(AdminAbstractsRoutesComponent) as any);



// WEBPACK FOOTER //
// ./src/containers/adminAbstracts/Routes.tsx